<template>
  <v-container>
    <EventForm/>
  </v-container>
</template>

<script>

import EventForm from "@/components/molecules/EventForm";

export default {
  components: { EventForm },
};
</script>
